import { render, staticRenderFns } from "./no_lawsuit_index.vue?vue&type=template&id=7201bdd0&scoped=true"
import script from "./no_lawsuit_index.vue?vue&type=script&lang=js"
export * from "./no_lawsuit_index.vue?vue&type=script&lang=js"
import style0 from "./no_lawsuit_index.vue?vue&type=style&index=0&id=7201bdd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7201bdd0",
  null
  
)

export default component.exports